import { render } from "./BeneficiaryDetail.vue?vue&type=template&id=53ed07b2&scoped=true"
import script from "./BeneficiaryDetail.js?vue&type=script&lang=js&external"
export * from "./BeneficiaryDetail.js?vue&type=script&lang=js&external"

import "./BeneficiaryDetail.scss?vue&type=style&index=0&id=53ed07b2&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ed07b2"]])

export default __exports__